<template>
  <v-card flat>
    <v-card-text>
      <v-form>
        <v-card flat>
          <v-card-title>Vehicle Preview Data</v-card-title>
          <v-container>
            <v-row no-gutters>
              <v-col cols="2" offset="0">
                <v-text-field v-model="vehicle_year" label="Vehicle Year" type="number"></v-text-field>
              </v-col>
              <v-col cols="2" offset="1">
                <v-text-field v-model="vehicle_make" label="Vehicle Make"></v-text-field>
              </v-col>
              <v-col cols="2" offset="1">
                <v-text-field v-model="vehicle_model" label="Vehicle Model"></v-text-field>
              </v-col>
              <v-col cols="2" offset="1">
                <v-text-field v-model="vehicle_vin" label="VIN"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-form>
    </v-card-text>
  </v-card>

</template>

<script>

export default {
  name: 'rooftop-preview-data',
  components: {
  },
  props: {
    value: {
      required: false,
      type: Object
    }
  },
  computed: {
    vehicle_year: {
      get: function () { return this.value.preview_data['vehicle_year'] },
      set: function (val) { this.updateModel('vehicle_year', val) }
    },

    vehicle_make: {
      get: function () { return this.value.preview_data['vehicle_make'] },
      set: function (val) { this.updateModel('vehicle_make', val) }
    },
    vehicle_model: {
      get: function () { return this.value.preview_data['vehicle_model'] },
      set: function (val) { this.updateModel('vehicle_model', val) }
    },
    vehicle_vin: {
      get: function () { return this.value.preview_data['vin'] },
      set: function (val) { this.updateModel('vin', val) }
    }
  },
  data: function () {
    return {

    }
  },
  methods: {
    updateModel (key, value) {
      const previewData = { ...this.value.preview_data, [key]: value }
      const updatedModel = { ...this.value, preview_data: previewData }
      this.$emit('input', updatedModel)
    }
  }
}
</script>
